"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapKeysDeep = void 0;

var _lodash = _interopRequireDefault(require("lodash.isobject"));

var _lodash2 = _interopRequireDefault(require("lodash.mapkeys"));

var _lodash3 = _interopRequireDefault(require("lodash.mapvalues"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapKeysDeep = function mapKeysDeep(obj, cb) {
  if (Array.isArray(obj)) {
    return obj.map(function (val) {
      return mapKeysDeep(val, cb);
    });
  } else if ((0, _lodash.default)(obj)) {
    return (0, _lodash3.default)((0, _lodash2.default)(obj, cb), function (val) {
      return (0, _lodash.default)(val) ? mapKeysDeep(val, cb) : val;
    });
  } else {
    return obj;
  }
};

exports.mapKeysDeep = mapKeysDeep;